import React from "react";
import Seo from "components/Seo";
import MorningLayout from "../../morningLayout";
import SignUp from "../../../common/-pages/auth/SignUp";
import { useAppContext } from "context/AppContext";

const MorningSignUp = () => {
    const { isApp } = useAppContext();

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="회원가입" />
            <div className={`flex flex-col relative  ${!isApp && "mt-[116px]"} flex-1`}>
                <MorningLayout>
                    <div className="flex-1 flex h-full flex-col items-center bg-[#F8F8F8] pb-48">
                        <p className="text-[#1B1C1E] text-[36px] font-bold mt-32 mb-8">회원가입</p>
                        <SignUp status="morning" />
                    </div>
                </MorningLayout>
            </div>
        </React.Fragment>
    );
};

export default MorningSignUp;
